import 'whatwg-fetch';
import callAPIHandler from './apiHandler';
import getAPIClient from './apiClient';
import ApplicationEntity from '../commonUtil/appEntity';
import { getLinkToken } from '../commonUtil/util';

let besDomain = '';

export const initBesDomain = (besUrl) => {
    besDomain = besUrl;
};

function callAPI(funName, args, apiName = 'bes', version = 'v1') {
    return callAPIHandler(getAPIClient(besDomain), apiName, version, funName, args);
}

export async function sharingLink(body = {}, sessionId = '') {
    const tenantId = ApplicationEntity.getInstance().tenantUniqueId;
    const linkUniqueId = getLinkToken();
    const result = await callAPI('sharingLink', { tenantId, linkUniqueId, sessionId, body }, 'bes', 'v2');
    return result;
}

export async function getMicroAppPagesCollection(interactionIdOrLinkToken = '', body = '', tenant) {
    const result = await callAPI('GetTiledPageviewsAsync', { interactionIdOrLinkToken, body, tenant });
    return result;
}

export async function getFeatureToggleByKey(tenantId, key) {
    const result = await callAPI('GetLaunchDarklyAsync', { key, tenantId });
    return !!(result && result.value);
}
